globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};

appCustomerSpace.LimitlessPlugins.Switch = (function () {

  Switch.selector = '[data-plugin="limitless.switch"]';

  Switch.init = function ($html) {
    $html.find(Switch.selector).each(function () {
      new Switch($(this));
    })
  }

  function Switch($html) {
    this.$html = $html;
    this.init();
  }

  Switch.prototype = {
    init: function () {
      var Switch = this,
        options = Switch.$html.data('plugin-options') || {},
        defaults = {
          color: helpers.white_space.main_color,
          toggle_target: this.$html.data('toggle-target'),
          toggle_invert: this.$html.data('toggle-invert') || false
        };

      this.config = $.extend({}, defaults, options, true);

      if (this.config.color === 'primary') this.config.color = '#2196F3';
      if (this.config.color === 'danger') this.config.color = '#EF5350';
      if (this.config.color === 'warning') this.config.color = '#FF7043';

      if (this.config.toggle_target) {
        this._toggleTarget();
      } else {
        this._propChecked();
      }

      new Switchery(this.$html[0], this.config);
    },
    _toggleTarget: function () {
      var _this = this,
        $target = $("#" + _this.config.toggle_target),
        invert = _this.config.toggle_invert;

      if ($target.length) {
        _this.$html.on('change', function () {
          var checked = _this.$html.prop("checked");
          if (invert ? !checked : checked) {
            $target.show();
          } else {
            $target.hide();
          }
        });
      }
    },
    _propChecked: function () {
      var _this = this;
      _this.$html.on('change', function () {
        _this.$html.attr("checked", !_this.$html.attr("checked"));
      });
    }
  }

  return Switch;

})();

appCustomerSpace.LimitlessPlugins.BootstrapSwitch = (function () {

  BootstrapSwitch.selector = '[data-plugin="limitless.bootstrap-switch"]';

  BootstrapSwitch.init = function ($html) {
    $html.find(BootstrapSwitch.selector).each(function () {
      new BootstrapSwitch($(this));
    })
  }

  function BootstrapSwitch($html) {
    this.$html = $html;
    this.init();
  }

  BootstrapSwitch.prototype = {
    init: function () {
      var Switch = this,
        options = Switch.$html.data('plugin-options') || {},
        defaults = {
          color: helpers.white_space.main_color
        };

      this.config = $.extend({}, defaults, options, true);

      if (this.config.color === 'primary') this.config.color = '#2196F3';
      if (this.config.color === 'danger') this.config.color = '#EF5350';
      if (this.config.color === 'warning') this.config.color = '#FF7043';

      if (this.config.toggle_target) {
        this._toggleTarget();
      }

      this.$html.bootstrapSwitch();
    },
    _toggleTarget: function () {
      var _this = this,
        $target = $("#" + _this.config.toggle_target);

      if ($target.length) {
        _this.$html.on('change', function () {
          if (_this.$html.prop("checked")) {
            $target.show();
          } else {
            $target.hide();
          }
        });
      }
    }
  }

  return BootstrapSwitch;

})();

